module.exports = __webpack_public_path__ + "img/horizontal_4_2_8011.9e085e50.png";